export const BASE_URL =
  (import.meta.env?.VITE_API_BASE_URL as string | undefined) ||
  "http://127.0.0.1:8000/api/v1";
